import { render, staticRenderFns } from "./TrialAlert.vue?vue&type=template&id=6dbb9ec3"
import script from "./TrialAlert.vue?vue&type=script&lang=js"
export * from "./TrialAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports